var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.155,
    height: 31.155,
    viewBox: "0 0 31.155 31.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    transform: "translate(94.959 -96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2863",
    "data-name": "Path 2863",
    d: "M15.577,0A15.577,15.577,0,1,1,0,15.578,15.578,15.578,0,0,1,15.577,0Z",
    transform: "translate(-94.959 96)",
    fill: "#1f94a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2864",
    "data-name": "Path 2864",
    d: "M81.949,86.445h2.917V76.722H81.949ZM93.312,76.386a4.378,4.378,0,0,0-3.581,1.658V76.69H86.8v9.754h2.928V81.17a2.316,2.316,0,0,1,2.3-2.2c1.279,0,1.595,1.088,1.595,2.175v5.3h2.917V80.925C96.544,77.092,94.729,76.386,93.312,76.386Zm-9.919-.635a1.46,1.46,0,1,0-1.46-1.46A1.461,1.461,0,0,0,83.393,75.751Z",
    transform: "translate(-168.13 30.959)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLinkedin);
export default __webpack_public_path__ + "static/media/blue-linkedin.c07d0a203c0a8fbb7bcee36b12a1ebce.svg";
export { ForwardRef as ReactComponent };